import { Tabs, rem } from '@mantine/core';

export default Tabs.extend({
  styles: {
    list: {
      gap: rem(6),
    },
    tab: {
      fontWeight: 600,
      color: 'var(--mantine-color-gray-5)',
      padding: '12px 8px 12px 8px',
    },
  },
});
